/* eslint-disable import/prefer-default-export */
import React from 'react';
import { IconProps } from './IconProps';
import { SVGWrapper } from './SVGWrapper';

export const Menu: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style}>
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="18" x2="21" y2="18" />
    </SVGWrapper>
);
